import { useState } from 'react';
import * as Sentry from '@sentry/react';
import { Button } from '@/components/ui/button';

/**
 * Sandbox page for manual QA of the global Error Boundary (S5-FE-01).
 * Only accessible in non-production environments.
 */

function BuggyChild(): JSX.Element {
  throw new Error('Manual render error from /sandbox/error-trigger');
}

export default function SandboxErrorTrigger() {
  const [shouldThrow, setShouldThrow] = useState(false);
  const [sentryStatus, setSentryStatus] = useState<string | null>(null);

  if (shouldThrow) {
    return <BuggyChild />;
  }

  function handleSentryPing() {
    const eventId = Sentry.captureMessage('[S5-FE-01] Sentry connectivity test from sandbox', 'info');
    if (eventId) {
      setSentryStatus(`✅ Enviado — event ID: ${eventId}`);
    } else {
      setSentryStatus('⚠️ Sentry no está inicializado (VITE_SENTRY_DSN no configurado)');
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-6 p-8 text-center">
      <h1 className="text-2xl font-bold">Error Boundary Sandbox</h1>

      {/* Test 1: verifica conectividad con Sentry sin ErrorBoundary */}
      <div className="flex flex-col gap-2 items-center border rounded-lg p-4 w-full max-w-sm">
        <p className="text-sm font-semibold">Test 1 — Sentry directo</p>
        <p className="text-muted-foreground text-xs">Envía un mensaje a Sentry sin pasar por el ErrorBoundary.</p>
        <Button variant="outline" onClick={handleSentryPing}>
          Enviar ping a Sentry
        </Button>
        {sentryStatus && <p className="text-xs mt-1">{sentryStatus}</p>}
      </div>

      {/* Test 2: verifica el flujo completo ErrorBoundary → Sentry */}
      <div className="flex flex-col gap-2 items-center border rounded-lg p-4 w-full max-w-sm">
        <p className="text-sm font-semibold">Test 2 — ErrorBoundary completo</p>
        <p className="text-muted-foreground text-xs">Lanza un error de render. Debe mostrar UI amigable y reportar a Sentry vía componentDidCatch.</p>
        <Button variant="destructive" onClick={() => setShouldThrow(true)}>
          Throw render error
        </Button>
      </div>
    </div>
  );
}

